import axios from '../utils/axiosInstance';

// All analytics endpoints accept optional { start_date, end_date } params.
const get = (path, params) => axios.get(`api/analytics/${path}`, { params }).then((r) => r.data);

export const api = {
  overview: (p) => get('overview/', p),
  quietTimes: (p) => get('quiet-times/', p),
  dayStats: (p) => get('day-stats/', p),
  holidays: (p) => get('holidays/', p),
  drinksWithFood: (p) => get('drinks-with-food/', p),
  receiptStats: (p) => get('receipt-stats/', p),
  revenueByWeekday: (p) => get('revenue-by-weekday/', p),
  productTrend: (group, p) => get('product-trend/', { group, ...p }),
  customTrend: (items, mode, p) => get('custom-trend/', { items: items.join(','), mode, ...p }),
  productNetwork: (p) => get('product-network/', p),
  productTiming: (items, p) => get('product-timing/', { items: items.join(','), ...p }),
  revenueGroups: (p) => get('revenue-groups/', p),
  menuEngineering: (p) => get('menu-engineering/', p),
  periodReport: (p) => get('period-report/', p),
  receiptsList: (p) => get('receipts-list/', p),
  forecast: () => get('forecast/'),
  dataRange: () => get('data-range/'),
  reportsList: () => get('reports/'),
  reportBlob: (key, download) => axios.get(`api/analytics/report/${key}/`,
    { params: { download: download ? 1 : 0 }, responseType: 'blob' }).then((r) => r.data),
  topFoodProducts: (p) => get('top-food-products/', p),
  daypartRevenue: (p) => get('daypart-revenue/', p),
  growth: () => get('growth/'),
  receiptDistribution: (p) => get('receipt-distribution/', p),
  groupInsights: (group) => get('group-insights/', { group }),
  basketComposition: (p) => get('basket-composition/', p),
  priceTrends: (p) => get('price-trends/', p),
  discounts: (p) => get('discounts/', p),
  popularityByTime: (p) => get('popularity-by-time/', p),
  weekdayBasket: (p) => get('weekday-basket/', p),
  basketProfile: (p) => get('basket-profile/', p),
  basketRules: (p) => get('basket/', p),
  paymentMethods: (p) => get('payment-methods/', p),
  groups: () => get('groups/'),
  productsTable: (p) => get('products-table/', p),
  productOverview: (p) => get('product-overview/', p),
  mapping: () => get('mapping/'),
  setMapping: (body) => axios.post('api/analytics/mapping/set/', body).then((r) => r.data),
  categories: () => get('categories/'),
  setCategoryRemap: (body) => axios.post('api/analytics/categories/remap/', body).then((r) => r.data),
  dataStatus: () => get('data-status/'),
  lightspeedStatus: () => get('lightspeed/status/'),
  lightspeedConnect: (body) => axios.post('api/analytics/lightspeed/connect/', body).then((r) => r.data),
  lightspeedDisconnect: () => axios.post('api/analytics/lightspeed/disconnect/', {}).then((r) => r.data),
  lightspeedSync: (body) => axios.post('api/analytics/lightspeed/sync/', body).then((r) => r.data),
  packaging: () => get('packaging/'),
  setPackagingItem: (body) => axios.post('api/analytics/packaging/item/', body).then((r) => r.data),
  setPackagingMap: (body) => axios.post('api/analytics/packaging/map/', body).then((r) => r.data),
  addPackagingEvent: (body) => axios.post('api/analytics/packaging/event/', body).then((r) => r.data),
  uploadLightspeed: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post('api/analytics/upload-lightspeed/', fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
};

export default api;
